import { create } from 'zustand';

// Stable ID sequence for Fabric objects (avoids DnD snap-back on reorder)
let __photoAdsLayerSeq = 1;

// Photo+ Ads plugin store (tools, colors, brush, adjustments, UI tabs, canvas/layers)
export const usePhotoAddsStore = create((set, get) => ({
  // Tools
  selectedTool: 'select',
  setSelectedTool: (tool) => set({ selectedTool: tool }),

  // Brush & colors
  brushSize: 5,
  setBrushSize: (size) => set({ brushSize: size }),
  fillColor: '#000000',
  setFillColor: (color) => set({ fillColor: color }),
  strokeColor: '#000000',
  setStrokeColor: (color) => set({ strokeColor: color }),
  strokeWidth: 2,
  setStrokeWidth: (w) => set({ strokeWidth: w }),

  // Text
  fontSize: 20,
  setFontSize: (v) => set({ fontSize: v }),
  fontFamily: 'Arial',
  setFontFamily: (v) => set({ fontFamily: v }),

  // Adjustments / Filters
  brightness: 100,
  contrast: 100,
  saturation: 100,
  opacity: 100,
  selectedFilter: 'none',
  setBrightness: (v) => set({ brightness: v }),
  setContrast: (v) => set({ contrast: v }),
  setSaturation: (v) => set({ saturation: v }),
  setOpacity: (v) => set({ opacity: v }),
  setSelectedFilter: (id) => set({ selectedFilter: id }),

  // UI
  activeTab: 0,
  setActiveTab: (i) => set({ activeTab: i }),

  // Canvas and layers
  canvas: null,
  setCanvas: (c) => set({ canvas: c }),
  layers: [],
  setLayers: (layers) => set({ layers }),
  selectedLayer: null,
  setSelectedLayer: (obj) => set({ selectedLayer: obj }),
  updateLayersFromCanvas: () => {
    const c = get().canvas;
    if (!c) return;
    const objects = c.getObjects();
    const layersList = objects.map((obj, index) => {
      // Assign a persistent layer ID once per object
      if (!obj.__layerId) {
        obj.__layerId = obj.id || `L${__photoAdsLayerSeq++}`;
      }
      return {
        id: obj.__layerId,
        name: obj.name || `Layer ${index + 1}`,
        type: obj.type,
        visible: obj.visible !== false,
        locked: obj.selectable === false,
        object: obj,
      };
    }).reverse();
    set({ layers: layersList, selectedLayer: c.getActiveObject() });
  },
}));
